// Work-around for https://app.asana.com/0/102902769366319/882764127630880/f
let isHistorySupported
try {
  isHistorySupported = !!window.history.length
} catch (err) {
  isHistorySupported = false
}

if (isHistorySupported) {
  module.exports = require('react-router-dom').BrowserRouter
} else {
  module.exports = require('./components/connected-memory-router')
}
